import React, { Component } from 'react';
import BodyClassName from 'react-body-classname';
import { connect } from 'react-redux';
import { CurrentStepSetAction } from '../../actions/action';
import { headTitleTag } from '../../helpers/functions';

import CONSTANTS from '../../constants';

import './home.css';
const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction };

class HomePage extends Component {


	componentDidMount() {
		// GA Start
		window.dataLayer.push({
			'brand': window.siteConfig['brandGTM'],
			'virtualPageURL': "/dealer-locator/searchwomap",
			'pageName': window.siteConfig['pageName'],
			'language': window.siteConfig['language'],
			'country': window.siteConfig['currentCountry'],
			'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
			'siteTypeLevel2': "appointement",
			'siteOwner': "central",
			'siteTarget': "B2C",
			'siteFamily': "after-sales",
			'pageCategory': "dealer locator page",
		});

		// GA Ends
		this.props.CurrentStepSetAction(1);
		// scroll to the top on user arrive to page
		window.scrollTo(0, 0);
	}
	render() {
		const SEO_TITLE = (window.siteConfig.v2homepage != undefined ? window.siteConfig.v2homepage.Title : '');
		const SEO_DESC = (window.siteConfig.v2homepage != undefined ? window.siteConfig.v2homepage.MetaDescription : '');

		return (
			<div>
				<BodyClassName className="page--home" />

				{
					headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()),
						SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
				}
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
